<script lang="ts">
  import { debounce } from 'lodash-es'
  import { setContext } from 'svelte'
  import type { FlashState } from '#app/lib/components/flash.svelte'
  import DeduplicateHomonyms from '#entities/components/deduplicate/deduplicate_homonyms.svelte'
  import ActorFollowersSection from '#entities/components/layouts/actor_followers_section.svelte'
  import SubEntitiesBrowser from '#entities/components/layouts/sub_entities_browser.svelte'
  import Summary from '#entities/components/layouts/summary.svelte'
  import { getSubEntitiesSections, type SubEntitiesBrowserSectionData } from '#entities/components/lib/entities'
  import { runEntityNavigate } from '#entities/lib/document_metadata'
  import type { SerializedEntity } from '#entities/lib/entities'
  import Spinner from '#general/components/spinner.svelte'
  import BaseLayout from './base_layout.svelte'
  import EntityTitle from './entity_title.svelte'
  import Infobox from './infobox.svelte'

  let {
    entity = $bindable(),
  }: {
    entity: SerializedEntity
  } = $props()

  let flash: FlashState | undefined = $state()

  const uri = $derived(entity.uri)
  $effect(() => void runEntityNavigate(entity))

  setContext('layout-context', 'collection')
  $effect(() => void setContext('search-filter-claim', `wdt:P195=${uri}`))
  // TODO: index editions
  // setContext('search-filter-types', null)

  let sections: SubEntitiesBrowserSectionData[] | undefined = $state()
  let waitingForSubEntities = $state()
  function getSections () {
    waitingForSubEntities = getSubEntitiesSections({ entity })
      .then(res => sections = res)
      .catch(err => flash = err)
  }
  const lazyGetSections = debounce(getSections, 100)
  $effect(() => {
    if (entity) lazyGetSections()
  })
</script>

<BaseLayout
  {entity}
  bind:flash
>
  {#snippet entityLayoutMain()}
    <div class="entity-layout">
      <div class="top-section">
        <div class="work-section">
          <EntityTitle {entity} />
          <Infobox
            claims={entity.claims}
            entityType={entity.type}
          />
          <Summary {entity} />
        </div>
        <div class="editions">
          {#await waitingForSubEntities}
            <Spinner center={true} />
          {:then}
            <SubEntitiesBrowser {sections} />
          {/await}
        </div>
      </div>
      <ActorFollowersSection uri={entity.uri} />
      <DeduplicateHomonyms {entity} />
    </div>
  {/snippet}
</BaseLayout>

<style lang="scss">
  @import "general/scss/utils";
  .entity-layout{
    align-self: stretch;
    @include display-flex(column, stretch);
    :global(.summary.has-summary){
      margin-block-start: 1em;
    }
  }
  .editions{
    margin-block-start: 1em;
  }
</style>
